<!--
TODO idea

Make the component work in two different ways. First is the old pill look but watch out the font is monospace or fake it to be monospace.
The other one is inline like now.
Also implement a few prop options as suggested below.

This was the icon used.
<SBIcon
  :icon="SBIconList.WHATSAPP_LOGO_THICK"
  :color="SBColors.blackPrimary"
  :size="12"
  class="" />
-->

<template>
  <div
    id="countdown"
    class="flex flex-align-center"
    :class="{raw: raw}" >
    <span
      v-if="timeUp"
      class="hourglass" >⌛</span>
    <span
      v-else
      class="hourglass" >⏳</span>
    <span
      class="time-left"
      :class="{initializing}" >{{ timeLeft }}</span>
    <b-popover
      id="countdown-popover"
      target="countdown"
      triggers="hover"
      placement="bottom" >
      <h1>WhatsApp 24 hours window</h1>
      <p>Based on WhatsApp Business Policies, if more than 24 hours have passed from the
        last message sent by the contact, you may only follow up by sending an approved
        WhatsApp Message Template.</p>
      <!-- TODO add the link -->
      <p> Learn more about WhatsApp Business Policies
        <a
          class="link"
          href="https://www.whatsapp.com/legal/business-policy/"
          target="_blank">here</a>.
      </p>
    </b-popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

import { doubleDigit } from '@/helpers/numberFormat';
import SBColors from '@/helpers/lists/colors';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'Last24HourCountdown',
  props: {
    // Do not apply any styling
    raw: {
      type: Boolean,
      required: false,
      default: false,
    },
    // TODO
    icon: {
      type: Object,
      required: false,
      default: () => {},
    },
    // TODO - always shown at the moment
    showSandClock: {
      type: Boolean,
      required: false,
      default: false,
    },
    countdownFrom: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      timeLeft: 'Calculating...',
      timeInterval: null,
      timeUp: false,
      initializing: true,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
    }),
  },
  mounted() {
    this.timeInterval = setInterval(this.countdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: {
    /** Checks the time difference between now and last inbound message date. */
    countdown() {
      const lastInboundDate = this.countdownFrom ? this.countdownFrom : this.activeConversation.inbound_sent_at;
      // Only calculate when last inbound message is receved not more than 24h ago
      if (lastInboundDate && this.$moment().diff(this.$moment(false, false).unix(lastInboundDate), 'days') === 0) {
        const elapsedSeconds = this.$moment().diff(this.$moment(false, false).unix(lastInboundDate), 'seconds');
        const remainingSeconds = 86400 - elapsedSeconds; // One day in seconds - elapsed seconds
        const duration = moment.duration(remainingSeconds, 'seconds');
        if (remainingSeconds < 3600) { // This is the last hour countdown
          this.timeLeft = `${doubleDigit(duration.minutes())}:${doubleDigit(duration.seconds())} left`;
        } else { // if not last hour then just show hours left
          // We need to add 1 hour because we need to ceil it to a higher value.
          // e.g. When user sends a message the counter will have a value of 23min59sec. Since we only wan't to see the hours we need to see 24.
          // e.g.2 When time left is 1h 1min we would show 1 and when it gets below 1h we show minute counter. It feels wrong. It shoud show 2h when counter is at 1h 1min so it can show the minute counter when it gets below 1h.
          this.timeLeft = `${duration.hours() + 1}h left`;
        }
        this.timeUp = false;
      } else {
        // More than a day passed... just fix the countdown to zero
        this.timeLeft = 'Session expired';
        this.timeUp = true;
      }
      this.initializing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#countdown {
  // width: fit-content;
  // height: 20px;
  // padding: 0 10px;
  // border-radius: 11px;
  // border: solid 1px #141c20;
  // background-color: #f8fafb;
  cursor: default;

  span {
    font-size: 12px;
    color: $blackPrimary;
    // margin-left: 4px;
    // min-width: 36px;
    // text-align: right;
    // line-height: 1.25;
  }

  .hourglass {
    margin-right: 5px;
    font-size: 10px;
  }

  .time-left {
    font-size: 14px;

    &.initializing {
      color: $greyPrimary;
    }
  }
}

#countdown-popover {
  max-width: 234px;
  margin-left: 0;
}
</style>
